import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
// import Hero5 from '../Hero/Hero5';
import { pageTitle } from '../../helper'
// import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
// import IconBox from '../IconBox'
// import PageHeading from '../PageHeading'
import { Icon } from '@iconify/react';
import Slider from 'react-slick';
import Portfolio from '../Portfolio';
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'
// import PortfolioSlider2 from '../Slider/PortfolioSlider2';
import VerticalLinks from '../VerticalLinks';
import '../../components/ServiceList/servicelist.scss';
import parse from 'html-react-parser';



const portfolioData = [
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/c1.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/c2.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/c3.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/c4.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/c5.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/c6.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/c7.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/c8.png',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    href: '/portfolio',
    src: '/images/c9.png',
  },
];



const PortfolioSlider2 = () => {
  /** Slider Settings **/
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-prev slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
    >
      <Icon icon="bi:arrow-left" />
    </div>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-next slick-arrow' +
        (currentSlide === slideCount - 1 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
    >
      <Icon icon="bi:arrow-right" />
    </div>
  );
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    // Added autoplay settings
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <Slider {...settings} className="cs-gap-12 cs-arrow_style4">
      {portfolioData.map((item, index) => (
        <Div key={index}>
          <Portfolio
            title={item.title}
            subtitle={item.subtitle}
            href={item.href}
            src={item.src}
            variant="cs-style1 cs-type2 cs-size3"
          />
        </Div>
      ))}
    </Slider>
  );
}



const HeaderBg = ({
  title,
  subtitle,
  btnLink,
  btnText,
  socialLinksHeading,
  heroSocialLinks,
}) => {
  return (
    <Div
      className="cs-hero cs-style3 cs-bg cs-fixed_bg cs-shape_wrap_1"
      id="home"
    >
      <Div className="cs-shape_1" />
      <Div className="cs-shape_1" />
      <Div className="cs-shape_1" />
      <Div className="cs-circle_1" />
      <Div className="cs-circle_2" />
      <Div className="container">
        <Div className="cs-hero_text text-center">
          <h1 className="cs-hero_title">{parse(title)}</h1>
          <Div className="cs-hero_subtitle">{subtitle}</Div>
          {btnText && btnLink && (
            <Button className="cs-hero_button" link={btnLink}>
              {btnText}
            </Button>
          )}
        </Div>
      </Div>
      {heroSocialLinks && (
        <VerticalLinks
          data={heroSocialLinks}
          title={socialLinksHeading}
          variant="cs-left_side"
        />
      )}
    </Div>
  );
};

// ✅ Export HeaderBg as Named Export
export { HeaderBg };


const heroSocialLinks = [
  {
    name: 'Instagram',
    links: 'https://www.instagram.com/justchargemedia/',
  },
  {
    name: 'Linkedin',
    links: 'https://www.linkedin.com/company/justchargemedia/posts/?feedView=all',
  },
];

const serviceData = [
  {
    title: 'Discovery & Research',
    subtitle:
      'Understanding your market, competitors, and audience.',
    imgUrl: '/images/cc11.png',
    href: '/service',
  },
  {
    title: 'Brand Strategy ',
    subtitle:
      'Defining voice, positioning, and messaging.',
    imgUrl: '/images/cc7.png',
    href: '/service',
  },
  {
    title: 'Identity Design',
    subtitle:
      'Creating a memorable visual identity (logo, colors, typography).',
    imgUrl: '/images/cc8.png',
    href: '/service',
  },
  {
    title: 'Brand Guidelines',
    subtitle:
      'Setting the foundation for consistent brand usage.',
    imgUrl: '/images/cc9.png',
    href: '/service',
  },
  {
    title: 'Execution & Rollout ',
    subtitle:
      'Applying branding across platforms (website, social media, packaging). ',
    imgUrl: '/images/cc10.png',
    href: '/service',
  },
];

const ServiceList = ({ variant }) => {
  const [active, setActive] = useState(0);
  const handelActive = index => {
    setActive(index);
  };
  return (
    <Div className={`cs-iconbox_3_list ${variant ? variant : ''}`}>
      {serviceData.map((item, index) => (
        <Div
          className={`cs-hover_tab ${active === index ? 'active' : ''}`}
          key={index}
          onMouseEnter={() => handelActive(index)}
        >
          <Link to={item.href} className="cs-iconbox cs-style3">
            <>
              <Div className="cs-image_layer cs-style1 cs-size_md">
                <Div className="cs-image_layer_in">
                  <img
                    src={item.imgUrl}
                    alt="Thumb"
                    className="w-100 cs-radius_15"
                  />
                </Div>
              </Div>
              <span className="cs-iconbox_icon cs-center">
                <svg
                  width={30}
                  height={29}
                  viewBox="0 0 30 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.3803 3.05172C29.4089 1.94752 28.537 1.02921 27.4328 1.00062L9.43879 0.534749C8.33459 0.506159 7.41628 1.37811 7.38769 2.48231C7.35911 3.58651 8.23106 4.50482 9.33526 4.53341L25.3299 4.94752L24.9158 20.9422C24.8872 22.0464 25.7592 22.9647 26.8634 22.9933C27.9676 23.0218 28.8859 22.1499 28.9144 21.0457L29.3803 3.05172ZM3.37714 28.5502L28.7581 4.4503L26.0039 1.54961L0.622863 25.6495L3.37714 28.5502Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <Div className="cs-iconbox_in">
                <h2 className="cs-iconbox_title">{item.title}</h2>
                <Div className="cs-iconbox_subtitle">{item.subtitle}</Div>
              </Div>
            </>
          </Link>
        </Div>
      ))}
    </Div>
  );
};


const accordionData = [
  {
    question: 'Why does branding matter for my business? ',
    answer:
      " A strong brand isn't just a logo; it’s the foundation of your business identity. It builds trust, makes you memorable, and helps you connect emotionally with your audience—ultimately driving more engagement and conversions.",
  },
  {
    question: 'How do you create a brand identity from scratch?',
    answer:
      ' We dive deep into your vision, values, and market position. Through workshops, competitive analysis, and creative brainstorming, we craft a brand story, logo, color palette, typography, and a compelling visual identity that resonates with your audience',
  },
  {
    question: 'Can you help rebrand my business without losing my existing audience?',
    answer:
      'Absolutely! We ensure your rebrand retains your core essence while evolving to stay relevant. We work on a smooth transition strategy to maintain customer trust while presenting your brand in a fresh and modern way.',
  },
  {
    question: 'What’s the timeline for a full branding process?',
    answer:
      ' It depends on the project scope, but a complete branding package typically takes 4–8 weeks, covering everything from discovery to brand guidelines.',
  },
  {
    question: 'What if I already have a logo? Can you enhance it?',
    answer:
      ' Yes! We can refine, modernise, or completely overhaul your logo while preserving the essence of your brand.',
  },
];

const CustomAccordion = () => {
  const [selected, setSelected] = React.useState(null);
  const handelToggle = index => {
    if (selected === index) {
      return setSelected(null);
    }
    setSelected(index);
  };

  return (
    <Div className="cs-accordians cs-style1">
      {accordionData.map((item, index) => (
        <Div
          className={`cs-accordian ${selected === index ? 'active' : ''}`}
          key={index}
        >
          <Div
            className="cs-accordian_head"
            onClick={() => handelToggle(index)}
          >
            <h2 className="cs-accordian_title">{item.question}</h2>
            <span className="cs-accordian_toggle cs-accent_color">
              <svg
                width={15}
                height={8}
                viewBox="0 0 15 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0L7.5 7.5L15 0H0Z" fill="currentColor" />
              </svg>
            </span>
          </Div>
          {selected === index && (
            <Div className="cs-accordian_body">
              <Div className="cs-accordian_body_in">{item.answer}</Div>
            </Div>
          )}
        </Div>
      ))}
    </Div>
  );
};



export default function ServiceDetailsPage() {
  pageTitle('Service Details');
  // const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <HeaderBg title="Crafting Brands That Resonate & Inspire" heroSocialLinks={heroSocialLinks} btnText="Let’s Build the Future Together!" btnLink='/contact' />



      <Spacing lg="90" md="70" />
      <PortfolioSlider2 />
      {/* <Spacing lg='145' md='80' /> */}
      {/* <Div className="container">
        <SectionHeading
          title=''
          subtitle=''
          variant='cs-style1 text-center'
        />
      
      </Div> */}
      <Spacing lg='90' md='45' />
      <ServiceList />



      <Spacing lg='150' md='80' />
      <TestimonialSlider />
      <Spacing lg='145' md='80' />
      <Div className="container cs-shape_wrap_4">
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-5 col-lg-6">
              <SectionHeading
                title='Some Pre Questions And Answers'
                subtitle='FAQs/Resources'
              />
              <Spacing lg='90' md='45' />
            </Div>
            <Div className="col-lg-6 offset-xl-1">
              <CustomAccordion />
            </Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg='150' md='80' />
      <Div className="container">
        <Cta
          title="Let&apos;s Build The <br />Next Big Thing Together! "
          btnText='Your Next Big Move Starts Here!'
          btnLink='/contact'
          bgSrc='/images/cta_bg.jpeg'
        />
      </Div>
    </>
  )
}